var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgJoinLeftOuter = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.772 11.187A4.733 4.733 0 0 0 10 8a4.733 4.733 0 0 0-1.228-3.187A3.748 3.748 0 0 0 7 8c0 1.345.708 2.525 1.772 3.187z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 4.127a4.75 4.75 0 1 0 0 7.747 4.751 4.751 0 0 1 0-7.747zm.772.686a3.75 3.75 0 1 1 0 6.374c-.231.256-.49.486-.772.686a4.75 4.75 0 1 0 0-7.747c.282.201.54.431.772.687z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgJoinLeftOuter);
export default ForwardRef;